<div class="success-container">
  <div class="success-content">
    <div class="success-icon">
      <!-- You can use an SVG for the checkmark -->
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="32" fill="#111" />
        <path d="M20 33.5L28.5 42L44 26.5" stroke="white" stroke-width="4" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </div>
    <div class="success-title">
      Success! <span class="emoji">🎉</span>
    </div>
    <div class="success-message">
      <h5 class="msg-title">Your RFQ has been successfully submitted.</h5>
      <h5 class="mb-2">What happens next:</h5>
      <p>
        Our team is reviewing your request and we may reach out <br>
        with more questions before we quote. We will be in touch shortly.
      </p>
    </div>
  </div>
</div>